import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Routes from '../../../../Layout/Routes';
import './AllReports.scss';

const ReportBackNav = () => {
  const navigate = useNavigate();

  return (
    <div className="report-back-nav">
      <button
        type="button"
        className="report-back-nav__btn"
        onClick={() => navigate(Routes.ALL_REPORTS)}
      >
        <ArrowBackOutlinedIcon fontSize="small" />
        <span>Back to All Reports</span>
      </button>
    </div>
  );
};

export default ReportBackNav;
